
/**
 * @export
 * @enum {string}
 */
export enum AlertType {
    SHOW_ONCE = 'SHOW_ONCE',
    SHOW_EVERY_LOGIN = 'SHOW_EVERY_LOGIN',
    SHOW_UNTIL_CLOSED = 'SHOW_UNTIL_CLOSED'
}